export const atelierEase = [0.22, 1, 0.36, 1] as const;

export const motionDurations = {
  quick: 0.24,
  reveal: 0.58,
  route: 0.42
} as const;

export const revealViewport = {
  once: true,
  amount: 0.16,
  margin: "0px 0px -8% 0px"
} as const;

export const revealTransition = {
  duration: motionDurations.reveal,
  ease: atelierEase
} as const;

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      delayChildren: 0.04,
      staggerChildren: 0.09
    }
  }
} as const;

export const staggerItem = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: revealTransition
  }
} as const;
